import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { Hero } from './components/Hero';
import { ProblemReframe } from './components/ProblemReframe';
import { HowItWorks } from './components/HowItWorks';
import { WhatsInside } from './components/WhatsInside';
import { LookInside } from './components/LookInside';
import { BuiltForBoth } from './components/BuiltForBoth';
import { BonusPack } from './components/BonusPack';
import { OfferSummary } from './components/OfferSummary';
import { GetStarted } from './components/GetStarted';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { BlockFlowLayer } from './components/BlockFlowLayer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="min-h-screen w-full bg-navy-900 font-sans antialiased" data-id="element-0" data-mp="28sl3uyeo7ofi">
      <BlockFlowLayer data-id="element-1" data-mp="23ujksdh8vp41" />
      <SiteHeader data-id="element-2" data-mp="23v2sl1d6kx4c" />
      <main data-id="element-3" data-mp="23ti6m04xmmi3">
        <Hero data-id="element-4" data-mp="3ik7gihlkcdr6" />
        <ProblemReframe data-id="element-5" data-mp="3ikh5c1uvgeva" />
        <HowItWorks data-id="element-6" data-mp="3ij668fcdfvai" />
        <WhatsInside data-id="element-7" data-mp="3ijpet5g4t7bv" />
        <LookInside data-id="element-8" data-mp="3mljat0fdtn5p" />
        <BuiltForBoth data-id="element-9" data-mp="3ml12v6jcxkhy" />
        <BonusPack data-id="element-10" data-mp="3mk86mzi0yde2" />
        <OfferSummary data-id="element-11" data-mp="3mjq27fl7ksv2" />
        <GetStarted data-id="element-12" data-mp="3mj6jhwnqi0fz" />
        <Faq data-id="element-13" data-mp="3rbr9en3irte8" />
        <FinalCta data-id="element-14" data-mp="3rbznujfaj6rj" />
      </main>
      <SiteFooter data-id="element-15" data-mp="3rcsuzli5vya7" />
    </div>;
}